// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__GK5-Y","logo":"style_logo__HQbg0"};